// Utilities
function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

// Site header section
theme.MSSiteHeaderSection = (function () {
  const header = document.querySelector(".ms-site-header"),
    megaMenuToggles = document.querySelectorAll(".ms-mega-menu-toggle"),
    mobileMenuButton = document.querySelector(
      ".ms-site-header__mobile-menu-button"
    ),
    mobileMenuEl = document.querySelector(".ms-mobile-menu"),
    searchLink = document.querySelector(".ms-site-header__search-button"),
    searchForm = document.querySelector(".ms-instant-search"),
    cartLink = document.querySelector(".ms-site-header__cart-button"),
    banner = document.querySelector(".ms-site-banner"),
    miniCart = document.querySelector(".ms-mini-cart");

  function MSSiteHeaderSection(container) {
    this.stickyHeader();
    this.currencyForm();
    this.menu();
    this.mobileMenu();
    this.search();
    this.cart();
  }

  MSSiteHeaderSection.prototype = $.extend({}, MSSiteHeaderSection.prototype, {
    showSearch: () => {
      const input = searchForm.querySelector(".ms-search-form__input");
      searchForm.classList.add("active");
      header.classList.add("ms-site-header--instant-search-active");
      searchLink.setAttribute("aria-expanded", "true");
      input.focus();
      document.body.classList.add("instant-search-active--lock-body");
    },
    hideSearch: () => {
      searchForm.classList.remove("active");
      header.classList.remove("ms-site-header--instant-search-active");
      searchLink.setAttribute("aria-expanded", "false");
      document.body.classList.remove("instant-search-active--lock-body");
    },
    showMiniCart: () => {
      header.classList.add("ms-site-header--mini-cart-active");
      banner.classList.add("ms-site-banner--mini-cart-active");
      cartLink.setAttribute("aria-expanded", "true");
      bodyScrollLock.disableBodyScroll(miniCart);
    },
    hideMiniCart: () => {
      header.classList.remove("ms-site-header--mini-cart-active");
      banner.classList.remove("ms-site-banner--mini-cart-active");
      cartLink.setAttribute("aria-expanded", "false");
      bodyScrollLock.enableBodyScroll(miniCart);
    },
    showMobileMenu: () => {
      mobileMenuButton.setAttribute("aria-expanded", "true");
      mobileMenuEl.classList.add("ms-mobile-menu--active");
      bodyScrollLock.disableBodyScroll(mobileMenuEl);
    },
    hideMobileMenu: () => {
      mobileMenuButton.setAttribute("aria-expanded", "false");
      mobileMenuEl.classList.remove("ms-mobile-menu--active");
      bodyScrollLock.enableBodyScroll(mobileMenuEl);
    },
    showMobileSubMenu: (event) => {
      const item = event.target.closest(".ms-mobile-menu__nav-list-item");
      const subMenu = item.querySelector(".ms-mobile-menu__nav--level-2");
      event.target.setAttribute("aria-expanded", "true");
      subMenu.classList.add("ms-mobile-menu__nav--level-2--active");
      mobileMenuEl.classList.add("ms-mobile-menu--sub-menu-active");
      bodyScrollLock.enableBodyScroll(mobileMenuEl);
      bodyScrollLock.disableBodyScroll(subMenu);
    },
    hideMobileSubMenus: (back) => {
      const buttons = document.querySelectorAll(
        ".ms-button ms-mobile-menu__nav--level-1__button"
      );
      const subMenus = document.querySelectorAll(
        ".ms-mobile-menu__nav--level-2"
      );
      buttons.forEach((button) =>
        button.setAttribute("aria-expanded", "false")
      );
      subMenus.forEach((subMenu) =>
        subMenu.classList.remove("ms-mobile-menu__nav--level-2--active")
      );
      mobileMenuEl.classList.remove("ms-mobile-menu--sub-menu-active");
      bodyScrollLock.clearAllBodyScrollLocks();
      if (back) bodyScrollLock.disableBodyScroll(mobileMenuEl);
    },

    stickyHeader: function () {
      // Update header class when page is scrolled
      const observer = new IntersectionObserver(
        ([e]) =>
          e.target.classList.toggle(
            "ms-site-header--scrolled",
            e.intersectionRatio < 1
          ),
        {
          rootMargin: "15px",
          threshold: 0,
        }
      );

      let toggled = false;

      const scrollObserver = function (e) {
        const scrollPosition = window.scrollY || window.pageYOffset;

        if (scrollPosition > 37 && !toggled) {
          header.classList.add("ms-site-header--scrolled");
          toggled = true;
        } else if (scrollPosition <= 37 && toggled) {
          header.classList.remove("ms-site-header--scrolled");
          toggled = false;
        }
      };

      if (header) {
        // observer.observe(header);
        window.addEventListener("scroll", scrollObserver);
      }
    },

    currencyForm: function () {
      // Submit currency form on change
      document.addEventListener("change", (event) => {
        if (event.target.matches("select[name='currency']")) {
          const form = event.target.closest("form");
          if (form) form.submit();
        }
      });
    },

    menu: function () {
      // Show and hide mega menus
      megaMenuToggles.forEach((toggle) => {
        const link = toggle.querySelector(".ms-nav-link");
        let linkActive = false;

        const showMenu = () => {
          toggle.classList.add("ms-mega-menu-toggle--active");
          link.setAttribute("aria-expanded", "true");
          header.classList.add("ms-site-header--mega-menu-active");
          this.hideSearch();
          this.hideMiniCart();
        };
        const hideMenu = () => {
          toggle.classList.remove("ms-mega-menu-toggle--active");
          link.setAttribute("aria-expanded", "false");
          header.classList.remove("ms-site-header--mega-menu-active");
          linkActive = false;
        };

        toggle.addEventListener("mouseover", showMenu);
        toggle.addEventListener("mouseout", hideMenu);

        // Disable first click on menu toggle links for touch devices
        link.addEventListener("click", (event) => {
          if (!linkActive && window.matchMedia("(hover: none)").matches) {
            event.preventDefault();
            linkActive = true;
          }
        });
      });
    },

    mobileMenu: function () {
      document.addEventListener("click", (event) => {
        if (event.target.closest(".ms-site-header__mobile-menu-button")) {
          this.showMobileMenu();
        } else if (
          event.target.closest(".ms-mobile-menu__header-button--close") ||
          event.target.matches(".ms-mobile-menu__overlay")
        ) {
          this.hideMobileMenu();
          this.hideMobileSubMenus();
          this.hideSearch();
        } else if (
          event.target.closest(".ms-mobile-menu__nav--level-1__button")
        ) {
          this.showMobileSubMenu(event);
        } else if (
          event.target.closest(".ms-mobile-menu__header-button--back")
        ) {
          this.hideMobileSubMenus(true);
        }
      });
    },

    search: function () {
      document.addEventListener("click", (event) => {
        if (event.target.closest(".ms-site-header__search-button")) {
          event.preventDefault();
          this.showSearch();
          this.hideMiniCart();
        } else if (
          event.target.closest(
            ".ms-site-header--instant-search-active .ms-site-header__overlay"
          )
        ) {
          this.hideSearch();
        }
      });
    },

    cart: function () {
      document.addEventListener("click", (event) => {
        if (event.target.closest(".ms-site-header__cart-button")) {
          event.preventDefault();
          this.showMiniCart();
          this.hideSearch();
        } else if (
          event.target.closest(
            ".ms-site-header--mini-cart-active .ms-site-header__overlay"
          ) ||
          event.target.closest(".ms-mini-cart__close-button")
        ) {
          this.hideMiniCart();
        }
      });
    },

    forceReload: function () {
      this.stickyHeader();
      this.currencyForm();
      this.menu();
      this.mobileMenu();
      this.search();
      this.cart();
    },

    onSelect: function () {},

    onDeselect: function () {},

    onUnload: function () {},
  });

  return MSSiteHeaderSection;
})();

theme.HomeFeaturedProductsSection = (function () {
  function HomeFeaturedProductsSection(container) {
    this.init();
  }

  HomeFeaturedProductsSection.prototype = $.extend(
    {},
    HomeFeaturedProductsSection.prototype,
    {
      init: function () {
        // Initialise feature products carousels
        $(".ms-home-featured-products__products-list.owl-carousel").owlCarousel(
          {
            margin: 4,
            stagePadding: 20,
            items: 2,
            nav: true,
            dots: true,
            dotsEach: true,
            responsive: {
              768: {
                items: 4,
              },
              992: {
                items: 4,
                stagePadding: 30,
              },
            },
          }
        );
      },

      forceReload: function () {
        this.init();
      },

      onSelect: function () {},

      onDeselect: function () {},

      onUnload: function () {},
    }
  );

  return HomeFeaturedProductsSection;
})();

// Collections view toggle
const collectionsViewToggle = () => {
  const collection = document.querySelector(".ms-collection");

  function setZoom(view, zoomLevel) {
    if (!view || !zoomLevel) return;

    if (view === "lg" && zoomLevel === "zoom") {
      collection.classList.add("ms-collection--zoom-lg");
      localStorage.setItem("ms-collection-lg-zoom", "true");
    } else if (view === "lg" && zoomLevel === "regular") {
      collection.classList.remove("ms-collection--zoom-lg");
      localStorage.setItem("ms-collection-lg-zoom", "false");
    } else if (view === "sm" && zoomLevel === "zoom") {
      collection.classList.add("ms-collection--zoom-sm");
      localStorage.setItem("ms-collection-sm-zoom", "true");
    } else if (view === "sm" && zoomLevel === "regular") {
      collection.classList.remove("ms-collection--zoom-sm");
      localStorage.setItem("ms-collection-sm-zoom", "false");
    }

    collectionsTextBlocks();
  }

  document.addEventListener("click", (event) => {
    if (event.target.closest(".ms-collection__view-toggle-button--lg-zoom")) {
      setZoom("lg", "zoom");
    } else if (
      event.target.closest(".ms-collection__view-toggle-button--lg-regular")
    ) {
      setZoom("lg", "regular");
    } else if (
      event.target.closest(".ms-collection__view-toggle-button--sm-zoom")
    ) {
      setZoom("sm", "zoom");
    } else if (
      event.target.closest(".ms-collection__view-toggle-button--sm-regular")
    ) {
      setZoom("sm", "regular");
    }
  });

  if (localStorage.getItem("ms-collection-lg-zoom") === "true") {
    setZoom("lg", "zoom");
  }

  if (localStorage.getItem("ms-collection-sm-zoom") === "true") {
    setZoom("sm", "zoom");
  }
};

// Collections text block positioning to match current layout
const collectionsTextBlocks = () => {
  const textBlocks = document.querySelectorAll(".ms-collection__text-block");
  const promoBlocks = document.querySelectorAll(".ms-collection__promo-block");
  const currentView = window.matchMedia("(min-width:992px)").matches
    ? "lg"
    : "sm";

  let itemsPerRow = 2;
  if (
    currentView === "sm" &&
    localStorage.getItem("ms-collection-sm-zoom") === "true"
  ) {
    itemsPerRow = 1;
  } else if (
    currentView === "lg" &&
    localStorage.getItem("ms-collection-lg-zoom") !== "true"
  ) {
    itemsPerRow = 4;
  }

  textBlocks.forEach((block) => {
    const assignedPos = parseInt(block.dataset.pos);

    // Check how many promo blocks have been inserted before this one
    let promoBlockCount = 0;
    promoBlocks.forEach((promo) => {
      const promoPos = parseInt(promo.dataset.pos);
      promoPos <= assignedPos ? promoBlockCount++ : "";
    });

    const modulo = (assignedPos + promoBlockCount) % itemsPerRow;

    // Update position of text block to fill the next row
    if (itemsPerRow === 1) {
      block.style.order = assignedPos;
    } else {
      if (modulo === 0) {
        block.style.order = assignedPos + 1;
      } else if (modulo === 1) {
        block.style.order = assignedPos;
      } else if (modulo === 2) {
        block.style.order = assignedPos + 3;
      } else if (modulo === 3) {
        block.style.order = assignedPos + 2;
      }
    }
  });
};

const debouncedCollectionsTextBlocks = debounce(
  () => collectionsTextBlocks(),
  300
);

// Run on page load
document.addEventListener("DOMContentLoaded", function () {
  // Register sections
  const sections = new theme.Sections();
  sections.register("ms-site-header-section", theme.MSSiteHeaderSection);
  sections.register(
    "ms-home-featured-products-section",
    theme.HomeFeaturedProductsSection
  );

  // Init template functions
  if (document.querySelector(".ms-collection")) {
    collectionsViewToggle();
    collectionsTextBlocks();
  }
});

// Run on window resize
window.addEventListener("resize", debouncedCollectionsTextBlocks);
